<style>
    .border-tab {
        border: solid 0.5px #a9a5a5;
    }

    .student {
        background-color: lightgray;
    }

    .teacher {
        background-color: #cbe8cb;
    }

    .myefforts {
        overflow-x: auto;
    }
</style>

<template>
    <v-card>
        <v-toolbar class="elevation1">
            <v-toolbar-title>
                {{ student }} Grade Summary
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
            append-icon="search"
            label="Search"
            flat
            v-model="search"
            solo
            ></v-text-field>
            <grade-summary-downloader :usertype="'student'" :userId="studentId"></grade-summary-downloader>
        </v-toolbar>
        <v-data-table
            :items="myEfforts"
            :pagination.sync="pagination"
            :rows-per-page-items="rowsPerPageItems"
            :total-items="totalItems"
            item-key="classId"
            :loading="loading"
            hide-actions
            class="elevation-1 myefforts"
          >
            <template slot="headers" slot-scope="props">
                <tr>
                    <th rowspan="2" class="border-tab">Class</th>
                    <th rowspan="2" class="border-tab">Teacher</th>
                    <th colspan="2" class="border-tab">{{diligenceLabel}}</th>
                    <th colspan="2" class="border-tab">{{engagementLabel}}</th>
                    <th colspan="2" class="border-tab">{{behaviourLabel}}</th>
                </tr>
                <tr>
                    <th class="border-tab student">Student-<br>Graded</th>
                    <th class="border-tab teacher">Teacher-<br>Graded</th>
                    <th class="border-tab student">Student-<br>Graded</th>
                    <th class="border-tab teacher">Teacher-<br>Graded</th>
                    <th class="border-tab student">Student-<br>Graded</th>
                    <th class="border-tab teacher">Teacher-<br>Graded</th>
                </tr>
            </template>
           
            <template slot="items" slot-scope="props" width="100%">
                <tr>
                    <td class="border-tab">{{ props.item.className }}</td>
                    <td class="border-tab">{{ props.item.teacher }}</td>
                    <td style="text-align: center" class="border-tab student">{{ props.item.diligenceStudent }}</td>
                    <td style="text-align: center" class="border-tab teacher">{{ props.item.diligenceTeacher }}</td> 
                    <td style="text-align: center" class="border-tab student">{{ props.item.engagementStudent }}</td>
                    <td style="text-align: center" class="border-tab teacher">{{ props.item.engagementTeacher }}</td>
                    <td style="text-align: center" class="border-tab student">{{ props.item.behaviourStudent }}</td>
                    <td style="text-align: center" class="border-tab teacher">{{ props.item.behaviourTeacher }}</td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { globalStore } from '../main'
import { getMyEffortsStudent, getTabsSettings } from '../utils/effort-tracking-api'
import GradeSummaryDownloader from './GradeSummaryDownloader'

export default {
    name: 'MyEffortsStudent',
    components:{
        GradeSummaryDownloader
    },
    data () {
        return {
            search: '',
            studentId: 0,
            student: '',
            loading: false,
            myEfforts: [],
            totalItems: 0,
            rowsPerPageItems: globalStore.rowsPerPageItems ,
            pagination: { sortBy: 'name', rowsPerPage: globalStore.defaultRowsPerPage, descending: false },
            headers: [
                { text: 'Class', value: 'name'},
                { text: 'Teacher', value: 'teacher', sortable: false },
                { text: 'Diligence', value: 'diligence', sortable: false },
                { text: 'Engagement', value: 'engagement', sortable: false },
                { text: 'Behaviour', value: 'behaviour', sortable: false }
            ],
            diligenceLabel: '',
            engagementLabel: '',
            behaviourLabel: ''
        }
    },
    created() {
        this.debouncedGetDataFromApi = _.debounce(this.getDataFromApi, 500, { trailing:true });
        this.studentId = this.$route.params.studentId;
        var studentData = this.$route.params.student;
        if(studentData !== undefined)
            this.student = studentData.lastName + ', ' + studentData.firstName + ' - ';

        this.debouncedGetDataFromApi();
    },
    mounted(){
        var progressBar = document.getElementsByClassName('v-datatable__progress')[0].childNodes[0];
        var noDataText = document.getElementsByClassName('text-xs-center')[0];
        noDataText.setAttribute('colspan', '8');
        progressBar.setAttribute('colspan', '8');

        getTabsSettings().then(tabs => {
                    var diligence = tabs.filter(tb => tb.name == 'DILIGENCE')[0];
                    this.diligenceLabel = (diligence.customName !== '' ) ? diligence.customName : diligence.name;

                    var engagement = tabs.filter(tb => tb.name == "ENGAGEMENT")[0];
                    this.engagementLabel = (engagement.customName !== '' ) ? engagement.customName : engagement.name;

                    var behaviour = tabs.filter(tb => tb.name == "BEHAVIOUR")[0];
                    this.behaviourLabel = (behaviour.customName !== '' ) ? behaviour.customName : behaviour.name;

                }).catch(ex => console.log(ex));
    },
    watch: {
      search: {
        handler () {
           this.debouncedGetDataFromApi()
        },
      },
      pagination: {
        handler () {
            this.debouncedGetDataFromApi();
        },
        deep: true
      }
    },
    methods: {
        getDataFromApi() {
            this.loading = true;
            getMyEffortsStudent(this.studentId, this.pagination, this.search).then(result => {
                this.student = result.studentName + ' - ';

                result.efforts.forEach(element => {
                    this.myEfforts.push(element[0]);
                });
                this.loading = false;
            }).catch(ex => { 
                console.log(ex); 
                this.loading = false; 
            });
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (to.meta.requiresResourceProperty && vm.$store.state.usertype == 'student')
            {
                if (parseInt(vm.$store.state.userdata.id) !== parseInt(vm.$route.params.studentId))
                {
                    vm.$route.params.studentId = vm.$store.state.userdata.id;
                    window.location.href = '#/';

                }
            }
        });
    }
}
</script>


// WEBPACK FOOTER //
// src/components/MyEffortsStudent.vue